"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerProvider = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
/**
 * @deprecated Use `LoggerProvider` from `@shared-ui/logger-context` instead.
 *
 * Provider component that injects a runtime `LoggerFactory`
 * function into the child context of the component tree.
 */
var LoggerProvider = /** @class */function (_super) {
  tslib_1.__extends(LoggerProvider, _super);
  function LoggerProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LoggerProvider.prototype.render = function () {
    return React.Children.only(this.props.children);
  };
  LoggerProvider.prototype.getChildContext = function () {
    return {
      factory: this.props.factory
    };
  };
  LoggerProvider.contextTypes = {
    factory: PropTypes.func
  };
  LoggerProvider.childContextTypes = {
    factory: PropTypes.func
  };
  return LoggerProvider;
}(React.Component);
exports.LoggerProvider = LoggerProvider;